import React from "react";
import {
  KYDAdminEvent,
  KYDAdminEventDetailSectionPermissions,
  KYDAdminEventDetailSectionsType,
} from "@common/interfaces/KYDEvent";
import type { EditModalType } from "../../../utils";

import TimelineSection from "../Timeline/TimelinesSection";
import LineupSection from "../Lineup/LineupSection";
import TicketTypesSection from "../TicketTypes/TicketTypesSection";
import TicketSalesSection from "../TicketSales/TicketSalesSection";
import EventDescription from "../Description/EventDescription";
import AccessCodesSection from "../AccessCodes/AccessCodesSection";
import StorySection from "../Story/StorySection";
import PromocodesSection from "../Promocodes/PromocodesSection";
import AffiliatesSection from "../Affiliates/AffiliatesSection";
import EventSummarySection from "../SummarySection/EventSummarySection";
import MarketingSection from "../Nav/Marketing/MarketingSection";
import CampaignsSection from "../Nav/Marketing/CampaignsSection";
import AttendeesSection from "../Nav/Attendees/AttendeesSection";
import PixelsSection from "../Nav/Marketing/PixelsSection";
import DemographicsSection from "../Nav/Analytics/DemographicsSection";
import ConversionSection from "../Nav/Analytics/ConversionSection";
import WaitlistSection from "../Nav/Waitlist/WaitlistSection";
import StatsSection from "../Nav/Analytics/StatsSection";
import ManagedCampaignsSection from "../Nav/Marketing/ManagedCampaigns/ManagedCampaignsSection";
import SettlementReportSection from "../Nav/Reporting/SettlementReportSection";

type PartialRecord<K extends keyof any, T> = {
  [P in K]?: T;
};

export type SectionProps<TData> = {
  data: TData;
  permissions?: KYDAdminEventDetailSectionPermissions;
  isLoading?: boolean;
  //
  onUpdateEvent?: (
    key: string,
    override_value?: string,
    onSuccess?: () => void
  ) => Promise<void>;
  setModalType?: (value: React.SetStateAction<EditModalType>) => void;
  modalType?: EditModalType;
  refetchEvent?: (options: any) => Promise<KYDAdminEvent>;
  pollForEventUpdateStatus?: () => Promise<boolean>;
};

export const sectionsComponents: PartialRecord<
  KYDAdminEventDetailSectionsType,
  (props: SectionProps<unknown>) => JSX.Element
> = {
  summary: EventSummarySection,
  ticket_sales: TicketSalesSection,
  timelines: TimelineSection,
  lineup: LineupSection,
  description: EventDescription,
  ticket_types: TicketTypesSection,
  access_codes: AccessCodesSection,
  story: StorySection,
  promo_codes: PromocodesSection,
  affiliates: AffiliatesSection,
  marketing_links: MarketingSection,
  campaigns: CampaignsSection,
  managed_campaigns: ManagedCampaignsSection,
  attendees: AttendeesSection,
  pixels: PixelsSection,
  demographics: DemographicsSection,
  conversion_funnel: ConversionSection,
  waitlist: WaitlistSection,
  stats: StatsSection,
  settlement_report: SettlementReportSection,
};
